(function() {
  'use strict';

  const RWRSizeGuideLeather = {
    init: function() {
      this.section = document.querySelector('.rwr-size-guide-leather');
      if (!this.section) return;
      
      this.bindEvents();
      this.initAccessibility();
    },

    bindEvents: function() {
      // Handle table row highlighting on focus for accessibility
      const tableRows = this.section.querySelectorAll('.rwr-size-guide__table tbody tr');
      
      tableRows.forEach(row => {
        row.setAttribute('tabindex', '0');
        
        row.addEventListener('focus', function() {
          this.classList.add('is-focused');
        });
        
        row.addEventListener('blur', function() {
          this.classList.remove('is-focused');
        });
      });
    },

    initAccessibility: function() {
      const table = this.section.querySelector('.rwr-size-guide__table');
      if (table) {
        table.setAttribute('role', 'table');
        table.setAttribute('aria-label', 'Leather dog collar size chart');
      }
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => RWRSizeGuideLeather.init());
  } else {
    RWRSizeGuideLeather.init();
  }

  // Reinitialize on Shopify section load (Theme Editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.rwr-size-guide-leather')) {
      RWRSizeGuideLeather.init();
    }
  });
})();